import { inject, Pipe, PipeTransform } from '@angular/core';
import { ProductionStatus } from '../../modules/mng/production-statuses/production-statuses.types';
import { ProductionStatusBadgeService } from '../components/production-status/production-status-badge.service';

@Pipe({
    standalone: true,
    name: 'productionStatus',
})
export class ProductionStatusPipe implements PipeTransform {
    productionStatusBadgeService = inject(ProductionStatusBadgeService);

    // A sample list of production statuses.
    private productionStatuses: ProductionStatus[] =
        this.productionStatusBadgeService.getCache('work_order');

    transform(status_id: number): string {
        if (status_id == null) {
            return '';
        }
        const status = this.productionStatuses.find(
            (s) => s.status_id === status_id
        );
        return status ? status.name : status_id.toString();
    }
}
